import {SearchBar} from '/ui/components/searchbar/searchbar';
import {yext} from '/ui/lib/msg';


/**
 * @param {{
 *   searchTerm: string,
 *   onSearch: function(string): void,
 * }} props
 * @returns {React.ReactElement}
 */
export const Search = ({
  searchTerm,
  onSearch,
}) => {
  return (<SearchBar
    onSearch={onSearch}
    placeholder={yext.msg('Search by Entity Name')}
    searchTerm={searchTerm}
  />);
};
